export var InboundMailItemStatus;
(function (InboundMailItemStatus) {
    InboundMailItemStatus["RECEIVED"] = "RECEIVED";
    InboundMailItemStatus["TRASHED"] = "TRASHED";
    InboundMailItemStatus["FORWARDED"] = "FORWARDED";
})(InboundMailItemStatus || (InboundMailItemStatus = {}));
